/**
 * 调用jsbridge写log.
 * 
 * @param {any} jsbridge 
 * @param {any} tag 
 * @param {any} level 
 * @param {any} logstr 
 */
var isCSR = typeof __VUE_SSR_CONTEXT__ !== 'undefined';
import env from '../common/env.js';


var Dom, log, runLog;
if(!isCSR) {
    function getWindow(){
        var win = {};
        try{
            if(top && top.window && top.window.document){
                win = top.window;
            }
        }catch(e){
            win = window;
        }
        return win;
    }
    Dom             = getWindow();
    runLog = function(jsbridge,tag,level,logstr){
        var levelMap = {
            '1':'info',
            '2':'warn',
            '3':'error'
        } // 后续等客户端支持日志等级，这里要删掉
        /** 就是这句关键的写log的话， */
        let logMsg = [
            '[WXGameH5Log]',            //强制的H5前缀，供分析用。
            '[' + levelMap[level] + ']',//log的等级。供分析用。
            '[' + tag + ']',            //某一个页面特定的标识。
            '\n',
            logstr,                     //具体log原因。
            '\n'
        ].join('')
        
        if( env.isMiniprogram() ) {
            const MiniProgramXLogMap = {
                "1": 'XLogManager.info',
                '2': 'XLogManager.warn',
                '3': 'XLogManager.error',
            };
            jsbridge.invoke('invokeMiniProgramAPI',{
                name: MiniProgramXLogMap[level],
                arg: logMsg,
            });
        }else {
            /** 就是这句关键的写log的话， */
            jsbridge.invoke('log',{
                msg:logMsg
            });
        }
    
        // console.log([
        //     '[WXGameH5Log]',            //强制的H5前缀，供分析用。
        //     '[' + levelMap[level] + ']',//log的等级。供分析用。
        //     '[' + tag + ']',            //某一个页面特定的标识。
        //     '\n',
        //     logstr,                     //具体log原因。
        //     '\n'
        // ].join(''));
    }
    
    /**
     * ready好weixinjsbridge。
     * 
     * @param {any} tag 
     * @param {any} level 
     * @param {any} logstr 
     */
    log = function(tag,level,logstr){
        var sep = '_';
        var tagPrefix = window.location.pathname.split('.html');    
        tagPrefix = tagPrefix[0].split('/').slice(-2);
        tagPrefix.push(tag);
        var modTag = tagPrefix.join('_');
        var win = Dom.window;
    
        if(win.WeixinJSBridge){
            runLog(
                win.WeixinJSBridge,
                modTag,level,logstr
            );
            
        }else{
            document.addEventListener('WeixinJSBridgeReady', function (){
                runLog(
                    win.WeixinJSBridge,
                    modTag,level,logstr
                );
            });
        }    
    };
}
/**
 * 把传入参数强制转为字符串。
 * 
 * @param {any} arguArr 
 */
var paramToStr = function(arguArr){
    arguArr = arguArr || [];

    return arguArr.map(function(item){
        if('object' == typeof item){
            try{
                item = JSON.stringify(item);
            }catch(e){
                item = item;
            }
        }
        if( 'string' != typeof item){
            item = '' + item;
        }
        return item;
    });
}
var lexports = {
    logInfo:function(tag){
        if(isCSR) return;
        try {
            var arguStr = Array.prototype.slice.apply(arguments);
            arguStr = paramToStr(arguStr);
            log(tag,1,arguStr.slice(1).join(' '));
        } catch (error) {
            console.error(error.message);
        }
        
    },
    logWarn:function(tag){
        if(isCSR) return;
        try{
            var arguStr = Array.prototype.slice.apply(arguments);
            arguStr = paramToStr(arguStr);
            log(tag,2,arguStr.slice(1).join(' '));
        } catch (error) {
            console.error(error.message);
        }
    },    
    logError:function(tag){
        if(isCSR) return;
        try{
            var arguStr = Array.prototype.slice.apply(arguments);
            arguStr = paramToStr(arguStr);
            log(tag,3,arguStr.slice(1).join(' '));
        } catch (error) {
            console.error(error.message);
        }
    }
};


if(!isCSR){
    /**
     * 否则把一切函数注入到window下。
     */
    for(var p in lexports){
        window[p] = lexports[p];
    }
}
export const logInfo = lexports.logInfo;
export const logWarn = lexports.logWarn;
export const logError = lexports.logError;
export default lexports;